import { storageService } from './storage-service'

/**
 * Shared replacement for the ~11 copy-pasted `readJson`/`writeJson` helpers.
 *
 * When `window` is absent (Node / vitest), I/O stays in the caller's memory map
 * so `reset*Memory()` helpers keep working. In the browser, every read and write
 * goes through `StorageService` — no direct `localStorage` access.
 */
export function createJsonMemoryAccessors<Slot extends string>(
  memory: Record<Slot, unknown>,
) {
  return {
    readJson<T>(key: string, slot: Slot, fallback: T): T {
      if (typeof window === 'undefined') {
        return (memory[slot] as T | null) ?? fallback
      }
      return storageService.getJSON(key, fallback)
    },
    writeJson<T>(key: string, slot: Slot, value: T): void {
      if (typeof window === 'undefined') {
        memory[slot] = value
        return
      }
      storageService.setJSON(key, value)
    },
  }
}
